import Route from 'cio/routes/base';
import { Crumb } from 'cio/services/crumbs';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import FeaturesService from 'ember-feature-flags/services/features';

export default class ObjectsRoute extends Route {
  @service auth!: AuthService;
  @service features!: FeaturesService;

  crumb(): Crumb {
    return {
      name: 'Objects Settings',
      path: this.routeName,
    };
  }
}
